import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-button',
  standalone: true,
  templateUrl: './button.component.html'
})
export class ButtonComponent {
  @Input() variant: 'primary' | 'secondary' | 'ghost' = 'primary';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() disabled = false;
  @Input() block = false;

  get baseClasses(): string {
    const base = 'inline-flex items-center justify-center gap-1.5 border font-semibold rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
    const sizes: Record<string, string> = {
      sm: 'px-4 py-2 text-xs',
      md: 'px-4 py-1.5 text-sm',
      lg: 'px-6 py-2.5 text-base'
    };
    const variants: Record<string, string> = {
      primary:   'bg-orange-500 text-white border-orange-500 hover:bg-orange-600 hover:border-orange-600 focus:ring-orange-400',
      secondary: 'bg-white text-orange-500 border-orange-300 hover:bg-orange-50 hover:border-orange-400 focus:ring-orange-300',
      ghost:     'bg-transparent text-orange-500 border-transparent hover:bg-orange-50 focus:ring-orange-300'
    };
    const width = this.block ? 'w-full' : '';
    return `${base} ${sizes[this.size]} ${variants[this.variant]} ${width}`.trim();
  }
}
